import { useEffect } from 'react';

/**
 * Hook to dynamically set the body background color or gradient
 * This ensures the safe area (top/bottom) matches the page background
 *
 * @param {string} color - The background to set
 *   Examples:
 *   - Solid color: '#ffffff' or '#3B82F6'
 *   - Gradient: 'linear-gradient(135deg, #3B82F6, #1D4ED8)'
 */
export function useBodyBackground(color) {
  useEffect(() => {
    const previousColor = document.body.style.background;
    const previousHtmlColor = document.documentElement.style.background;

    document.body.style.background = color;
    document.documentElement.style.background = color;

    return () => {
      document.body.style.background = previousColor;
      document.documentElement.style.background = previousHtmlColor;
    };
  }, [color]);
}
